import { connect, ConnectedProps } from "react-redux";
import {
  getHotelAvailabilityCallState,
  getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching,
  getFilteredAndSortedHotelAvailabilityLodgings,
} from "../../../availability/reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { MobileWishlistAvailability } from "./component";
import { withRouter } from "react-router-dom";
import { getFromDate, getUntilDate } from "../../../search/reducer";
import { setOpenDatesModal } from "../../../availability/actions/actions";
import {
  getTravelWalletCredit,
  getTravelWalletOffers,
} from "../../../travel-wallet/reducer";

const mapStateToProps = (state: IStoreState) => {
  const lodgings = getFilteredAndSortedHotelAvailabilityLodgings(state);
  const hotelAvailabilityCallState = getHotelAvailabilityCallState(state);
  const isFilteredHotelAvailabilityLodgingsEmpty =
    getIsFilteredHotelAvailabilityLodgingsEmptyAndDoneSearching(state);

  return {
    lodgings,
    hotelAvailabilityCallState,
    isFilteredHotelAvailabilityLodgingsEmpty,
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    walletItemCount: getTravelWalletCredit(state)
      ? getTravelWalletOffers(state).length + 1
      : getTravelWalletOffers(state).length,
  };
};

const mapDispatchToProps = () => {
  return {
    setOpenDatesModal,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileWishlistAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileWishlistAvailability = withRouter(
  connector(MobileWishlistAvailability)
);
